import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FuzzySearch from 'fuzzy-search';

import Dropdown from './Dropdown';

import vw from 'src/styles/utils';

const LawFirmSelector = ({ setLawFirmID, type, label, id }) => {
  const filterBy = 'name';
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [dropdownData, setDropdownData] = useState([]);
  const [dropdownHidden, setDropdownHidden] = useState(true);

  const [searcher, setSearcher] = useState(new FuzzySearch(data, [filterBy]));

  // GETS A LIST OF LAW FIRMS FROM THE MAKE API
  useEffect(() => {
    // test hook: https://hook.us1.make.com/jwel48qxbmewmro0pyub9il12tc0ut4t
    // production hook: https://hook.us1.make.com/oqru7xtpn9ji5lw2vyw9mu0vckme2lgh
    fetch('https://hook.us1.make.com/od94x88tv22a8e4sa97xd8cxe9kaznkh')
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Error: ' + response.status);
      })
      .then((json) => {
        const processedData = json.map((item) => ({
          id: item.id,
          name: item.name,
        }));

        setData(processedData);
        setSearcher(new FuzzySearch(processedData, [filterBy]));
      })
      .catch((error) => console.error('Error:', error));
  }, []);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  const handleDropdownClick = (id, name) => {
    setLawFirmID(name);
    setSearch(name);
  };

  useEffect(() => {
    const result = searcher.search(search);
    // console.log('data', data);
    // console.log('search', search);
    // console.log('result', result);
    setDropdownData(result);
  }, [search]);

  if (data) {
    return (
      <Root>
        <label className="text-label" htmlFor="lawFirm">
          {label}
        </label>
        <input
          className="uppercase"
          type={type}
          id={id}
          name={id}
          onChange={(e) => handleChange(e)}
          value={search}
          onFocus={() => setDropdownHidden(false)} // Dropdown becomes visible on input focus
          onBlur={() => {
            // Delay the hiding of dropdown, so the dropdown click can be processed
            setTimeout(() => {
              setDropdownHidden(true);
            }, 200);
          }}
        />
        <Dropdown
          dropdownData={dropdownData}
          handleDropdownClick={handleDropdownClick}
          hidden={dropdownHidden}
        />
      </Root>
    );
  } else {
    return <div>Loading...</div>;
  }
};

LawFirmSelector.propTypes = {
  className: PropTypes.string,
};

export default LawFirmSelector;

const Root = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  grid-area: ${(props) => props.gridArea};
  ${vw('margin-bottom', 5, 3, 15)}

  label {
    text-align: left;
    ${vw('margin-bottom', 10)}
    font-family: Big Caslon;
    ${vw('font-size', 18, 16)}
  }
  .error label {
    color: red;
  }
  input {
    border: none;
    /* border-bottom: 1px solid ${(props) => props.theme.color.black}; */
    box-sizing: border-box;
    background-color: #f1f0f0;
    color: ${(props) => props.theme.color.black};
    ${vw('height', 30)}
    ${vw('letter-spacing', 0.06)}
    ${vw('padding-left', 3, 5)}
  }
  input:disabled {
    opacity: 0.2;
  }
`;
